// Pure data: in-game instructions per game, in both languages. Text matches what
// OUR engines actually implement (e.g. checkers: forced captures, flying kings,
// men capturing backwards, 40-ply no-progress draw) — when a rule changes in an
// engine, update the matching entry here.

export const RULES = {
  checkers: {
    pl: {
      title: 'Warcaby — instrukcja',
      body: [
        '{target} Cel: zbij wszystkie pionki przeciwnika albo zablokuj mu ruchy.',
        '',
        '• Pionek chodzi o jedno pole po skosie, tylko do przodu.',
        '• Bicie: przeskakujesz pionek przeciwnika na wolne pole za nim — pionki biją także do tyłu!',
        '• Bicie jest obowiązkowe: jeśli możesz bić, musisz (wybierasz którym pionkiem i którą drogą).',
        '• Łańcuch: po biciu, jeśli ten sam pionek może bić dalej, bijesz dalej w tym samym ruchu.',
        '• Damka {crown}: pionek, który dotrze do ostatniego rzędu. Porusza się po skosie o dowolną liczbę pól i bije z daleka — sama wybierasz, na którym polu za zbitym pionkiem wylądować.',
        '• 40 ruchów bez bicia i bez ruchu zwykłym pionkiem = remis.',
      ].join('\n'),
    },
    en: {
      title: 'Checkers — how to play',
      body: [
        '{target} Goal: capture all enemy pieces or block them so they cannot move.',
        '',
        '• A man moves one square diagonally, forward only.',
        '• Capturing: jump over an enemy piece onto the empty square behind it — men capture backwards too!',
        '• Captures are mandatory: if you can capture, you must (you choose which piece and which path).',
        '• Chains: after a capture, if the same piece can capture again, it keeps jumping in the same turn.',
        '• King {crown}: a man that reaches the last row. It slides any number of squares diagonally and captures from afar — you choose the landing square behind the captured piece.',
        '• 40 moves with no capture and no man-move = draw.',
      ].join('\n'),
    },
  },

  chess: {
    pl: {
      title: 'Szachy — instrukcja',
      body: [
        '{target} Cel: daj mata — zaatakuj króla przeciwnika tak, żeby nie miał ucieczki.',
        '',
        '• Pionek ♙: 1 pole do przodu (2 z pozycji startowej), bije po skosie.',
        '• Wieża ♖: w pionie i poziomie. Goniec ♗: po skosach. Hetman ♕: jedno i drugie.',
        '• Skoczek ♘: w kształcie litery L — jako jedyny przeskakuje figury.',
        '• Król ♔: 1 pole w dowolną stronę.',
        '• Szach: twój król podświetla się na czerwono — musisz go obronić.',
        '• Roszada: kliknij króla, potem pole DWA pola w bok — wieża przeskoczy sama (o ile ani król, ani ta wieża jeszcze się nie ruszały i nic nie stoi pomiędzy).',
        '• Promocja: pionek na ostatnim rzędzie zamienia się w wybraną figurę (najczęściej hetmana!).',
        '• Bicie w przelocie: pionek może zbić pionka przeciwnika, który właśnie minął go ruchem o dwa pola.',
        '• Remis: pat (brak ruchów bez szacha), powtórzenia — albo zgoda obu graczy (przycisk {handshake}).',
      ].join('\n'),
    },
    en: {
      title: 'Chess — how to play',
      body: [
        '{target} Goal: checkmate — attack the enemy king so it has no escape.',
        '',
        '• Pawn ♙: 1 square forward (2 from its starting square), captures diagonally.',
        '• Rook ♖: straight lines. Bishop ♗: diagonals. Queen ♕: both.',
        '• Knight ♘: an L-shape — the only piece that jumps over others.',
        '• King ♔: 1 square in any direction.',
        '• Check: your king glows red — you must defend it.',
        '• Castling: click the king, then the square TWO squares sideways — the rook jumps by itself (as long as neither has moved and nothing stands between them).',
        '• Promotion: a pawn reaching the last row becomes a piece of your choice (usually a queen!).',
        '• En passant: a pawn may capture an enemy pawn that just rushed past it two squares.',
        '• Draws: stalemate (no legal moves, no check), repetition — or both players agree ({handshake} button).',
      ].join('\n'),
    },
  },

  mancala: {
    pl: {
      title: 'Mancala — instrukcja',
      body: [
        '{target} Cel: zbierz do swojego spichlerza więcej ziaren niż przeciwnik.',
        '',
        '• Twoje dołki to dolny rząd, a twój spichlerz jest po PRAWEJ stronie.',
        '• Ruch: kliknij swój dołek — zabierasz z niego wszystkie ziarna i rozsiewasz po jednym w kolejne dołki (w prawo, dookoła planszy), omijając spichlerz przeciwnika.',
        '• Ostatnie ziarno w TWOIM spichlerzu = dodatkowy ruch! {repeat}',
        '• Ostatnie ziarno w twoim PUSTYM dołku = bicie: zabierasz to ziarno oraz wszystkie ziarna z dołka naprzeciwka do swojego spichlerza.',
        '• Gdy któraś strona nie ma już ziaren w dołkach, druga strona zgarnia resztę swoich do spichlerza i gra się kończy.',
        '• Wygrywa ten, kto ma więcej ziaren w spichlerzu. Po równo = remis.',
      ].join('\n'),
    },
    en: {
      title: 'Mancala — how to play',
      body: [
        '{target} Goal: collect more seeds in your store than your opponent.',
        '',
        '• Your pits are the bottom row and your store is on the RIGHT.',
        '• Move: click one of your pits — you pick up all its seeds and sow them one by one into the following pits (rightwards, around the board), skipping your opponent\'s store.',
        '• Last seed in YOUR store = you move again! {repeat}',
        '• Last seed in your EMPTY pit = capture: that seed plus all seeds in the opposite pit go into your store.',
        '• When one side has no seeds left in its pits, the other side banks its remaining seeds and the game ends.',
        '• Whoever has more seeds in their store wins. Equal = draw.',
      ].join('\n'),
    },
  },
  backgammon: {
    pl: {
      title: 'Tryktrak — instrukcja',
      body: [
        '{target} Cel: jako pierwszy sprowadź wszystkie 15 pionków do swojego domu i zdejmij je z planszy.',
        '',
        '• Kierunek: pionki zawsze idą w stronę swojego domu — na dole po prawej. Kości mówią, o ile pól.',
        '• Dwie kości = dwa osobne ruchy (tym samym albo dwoma różnymi pionkami). Dublet (np. 4-4) daje CZTERY ruchy po 4 pola.',
        '• Musisz wykorzystać obie kości, jeśli to możliwe — a jeśli można zagrać tylko jedną, musisz zagrać tę WYŻSZĄ (o ile da się zagrać którąkolwiek).',
        '• Pole zajęte przez 2 lub więcej pionków przeciwnika jest zablokowane — nie możesz na nie wejść.',
        '• Pojedynczy pionek przeciwnika (blot) na polu, na które wchodzisz, zostaje zbity i trafia na bar.',
        '• Pionek na barze musi jako pierwszy wrócić na planszę (wejście od strony domu przeciwnika) — dopóki masz pionek na barze, nie możesz ruszać żadnym innym.',
        '• Zbieranie (bear off): gdy wszystkie twoje pionki są już w domu, zdejmujesz je z planszy — liczba oczek musi dokładnie odpowiadać polu, albo być wyższa, jeśli dalszych pionków już nie masz.',
        '• Brak możliwego ruchu = kolejka przechodzi na przeciwnika automatycznie.',
        '• Wygrywa gracz, który jako pierwszy zdejmie wszystkie 15 pionków. Remis możliwy tylko za zgodą obu graczy (przycisk {handshake}).',
      ].join('\n'),
    },
    en: {
      title: 'Backgammon — how to play',
      body: [
        '{target} Goal: be the first to bring all 15 checkers into your home board and bear them all off.',
        '',
        '• Direction: checkers always move toward your home — bottom-right. The dice tell you how many spaces.',
        '• Two dice = two separate moves (with the same checker or two different ones). A doublet (e.g. 4-4) gives you FOUR moves of 4 spaces each.',
        '• You must use both dice if at all possible — and if only one can be played, it must be the HIGHER one (whichever can actually be played).',
        '• A point held by 2 or more enemy checkers is blocked — you cannot land there.',
        '• A lone enemy checker (a blot) on the point you land on gets hit and sent to the bar.',
        '• A checker on the bar must re-enter first (entering from the opponent\'s home side) — while you have a checker on the bar, you cannot move any other piece.',
        '• Bearing off: once all your checkers are home, you remove them from the board — the die must match the point exactly, or be higher if you have no checkers further out.',
        '• No legal move = your turn is skipped automatically.',
        '• Whoever bears off all 15 checkers first wins. A draw only happens if both players agree ({handshake} button).',
      ].join('\n'),
    },
  },
};

export function hasRules(gameId) {
  return gameId in RULES;
}
